import { Button, Group, NumberInput, Stack, Switch, Title } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthorAdminReport } from '@/module/AnnualReport/perRole/AuthorAdminReport';
import { DepartmentAdminReport } from '@/module/AnnualReport/perRole/DepartmentAdminReport';
import { DisciplineAdminReport } from '@/module/AnnualReport/perRole/DisciplineAdminReport';
import { FacultyAdminReport } from '@/module/AnnualReport/perRole/FacultyAdminReport';
import { UniversityAdminReport } from '@/module/AnnualReport/perRole/UniversityAdminReport';

import { CustomSelect } from '@/core/components/Select';

import { useCurrentUser } from '@feature/security';
import { ValidationStatus } from '@feature/validation';

const startYear = new Date().getFullYear() - 1;

const validationOptions = [
  { label: 'Validat', value: 'VALIDATED' },
  { label: 'Respins', value: 'REJECTED' },
];

export function AnnualReport() {
  // A string here makes the input's blur, fired when the loading report hides it, write the old year back as a number.
  const [yearStr, setYearStr] = useState<number | string>(startYear);
  const year = yearStr != null && yearStr !== '' ? Number(yearStr) : startYear;
  const [validationStatus, setValidationStatus] = useState<ValidationStatus | null>(null);
  const [filterAfterAffiliation, setFilterAfterAffiliation] = useState<boolean>(true);

  const { t } = useTranslation();
  const { currentRole } = useCurrentUser();

  return (
    <Stack>
      <Group>
        <Title order={1}>
          {t('annualReport.title')} {year}
        </Title>
        {(currentRole === 'UNIVERSITY_ADMIN' || currentRole === 'FACULTY_ADMIN') && (
          <Button
            size="xs"
            component={Link}
            to="analytics"
          >
            Afișează situația centralizată
          </Button>
        )}
      </Group>
      <Group align="flex-end">
        <CustomSelect
          size="xs"
          label="Status validare"
          description="lăsați liber pentru a vedea toată situația"
          placeholder="tot"
          searchable
          data={validationOptions}
          value={validationStatus}
          onChange={status => setValidationStatus(status as ValidationStatus)}
          clearable
        />
        <Switch
          label={t('rectorReport.filterAfterAffiliation')}
          checked={filterAfterAffiliation}
          onChange={e => setFilterAfterAffiliation(e.currentTarget.checked)}
        />
        {currentRole === 'UNIVERSITY_ADMIN' && (
          <NumberInput
            size="xs"
            value={yearStr}
            onChange={setYearStr}
            label={t('annualReport.year')}
            placeholder={t('annualReport.year')}
          />
        )}
      </Group>
      {currentRole === 'AUTHOR' && (
        <AuthorAdminReport
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
      {currentRole === 'DISCIPLINE_ADMIN' && (
        <DisciplineAdminReport
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
      {currentRole === 'DEPARTMENT_ADMIN' && (
        <DepartmentAdminReport
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
      {currentRole === 'FACULTY_ADMIN' && (
        <FacultyAdminReport
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
      {currentRole === 'UNIVERSITY_ADMIN' && (
        <UniversityAdminReport
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
    </Stack>
  );
}
